// client/src/components/common/RadiusSlider.js

import React from "react";
import { Range, getTrackBackground } from "react-range";

const RadiusSlider = ({ radius, setRadius }) => {
  const MIN = 5;
  const MAX = 50;
  const STEP = 1;

  return (
    <div>
      <div className="px-2 py-2"> {/* Added padding */}
        <Range
          values={[radius]}
          step={STEP}
          min={MIN}
          max={MAX}
          onChange={(values) => setRadius(values[0])}
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: '36px',
                display: 'flex',
                width: '100%',
              }}
            >
              <div
                ref={props.ref}
                style={{
                  height: '8px', // Thicker track
                  width: '100%',
                  borderRadius: '4px',
                  // ✅ Use helper to create a colored track
                  background: getTrackBackground({
                    values: [radius],
                    colors: ['var(--bs-primary)', '#ccc'], // Use bootstrap primary color
                    min: MIN,
                    max: MAX,
                  }),
                  alignSelf: 'center',
                }}
              >
                {children}
              </div>
            </div>
          )}
renderThumb={({ props }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '24px',
                width: '24px',
                borderRadius: '50%',
                // ✅ Use the --bs-primary-rgb variable to ensure a solid color
                backgroundColor: 'rgb(var(--bs-primary-rgb))',
                boxShadow: '0px 2px 6px #AAA',
              }}
            />
          )}
        />
      </div>
      <div className="text-center mt-2">
        <span>{radius} miles</span>
      </div>
    </div>
  );
};

export default RadiusSlider;